import React, { useContext, useEffect, useState } from "react";
import arePropsEqual from "react-fast-compare";
import { useSelector } from "react-redux";
import { Checkbox } from "@mui/material";

//context
import { PartnersContext } from "../../PartnersContext";

//selectors
import {selectListData} from "../../../../../store/admin/partners/selectors";

//types
import { itemListData } from "../../../../common/TableData";



const SelectAllAffiliates = () => {
	const context = useContext(PartnersContext);
	const data = useSelector(selectListData);

	const [checked, setChecked] = useState<boolean>(false);

	useEffect(() => {
		if (!context.selectedPartners.length) {
			setChecked(false);
		}
	}, [context.selectedPartners]);

	useEffect(() => {
		if (!!data) {
			const idsA = new Set(context.selectedPartners.map(({ id }) => id));
			const allMatched = data.list.every(({ id }) => idsA.has(id));
			if (!allMatched) {
				setChecked(false)
			}
			if (allMatched) {
				setChecked(true)
			}
		}

	},[data, context.selectedPartners])

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setChecked(event.target.checked);
		if (!!data && event.target.checked) {
			context.setSelectedPartners((prevState:any) => {
				const toAdd = data.list.filter(item =>
					!prevState.some((existing:any) => existing.id === item.id)
				);
				return [...prevState, ...toAdd];
			});
		} else {
			context.setSelectedPartners((prevState:any) => {
				if (!data) return prevState;
				const incomingIds = new Set(data.list.map((item:any) => item.id));
				const filteredList =  prevState.filter((item:any) => !incomingIds.has(item.id));
				return filteredList;
			})
		}
	}

	return (
		<>
			<Checkbox
				size="small"
				sx={{ padding: '4px' }}
				checked={checked}
				onChange={handleChange}
				inputProps={{ 'aria-label': 'controlled' }}
			/>
		</>
	);
};

export default React.memo(SelectAllAffiliates, arePropsEqual);
